import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=0ba160c0&"
import script from "./SortControl.vue?vue&type=script&lang=js&"
export * from "./SortControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports